import { toastr } from 'react-redux-toastr'
import axios from 'axios'
import consts from '../consts'

export function login(values) {
    return submit(values, `${consts.OAPI_URL}/login`)
}

export function signup(values) {
    return submit(values, `${consts.OAPI_URL}/signup`)
}

function submit(values, url) {
    return dispatch => {
        axios.post(url, values)
            .then(resp => {
                dispatch([
                    { type: 'USER_FETCHED', payload: resp.data }
                ])
            })
            .catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }

            })
    }
}

export function logout() {
    return { type: 'TOKEN_VALIDATED', payload: false }
}

export function validateToken(token) {
    return dispatch => {
        if (token) {
            axios.post(`${consts.OAPI_URL}/validateToken`, { token })
                .then(resp => {
                    dispatch({ type: 'TOKEN_VALIDATED', payload: resp.data.valid })
                })
                .catch(e => dispatch({ type: 'TOKEN_VALIDATED', payload: false }))
        } else {
            dispatch({ type: 'TOKEN_VALIDATED', payload: false })
        }
    }
}

export function getCountUsers() {
    return dispatch => {
        axios.get(`${consts.OAPI_URL}/getcountuser`)
            .then(resp => {
                dispatch({ type: 'USER_QTD', payload: resp.data })
            })
            .catch(e =>console.log(e))
    }
}


// WEBPACK FOOTER //
// ./src/auth/authActions.js